import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Layout from "../components/common/layout/Index";
import useTranslationHook from "../components/hooks/useTranslationHook";
import { useDispatch } from "react-redux";
import { handlePrivateAuctionDetails } from "../redux/slice/buyerSlice";
const PrivateAuctionRestricted = () => {
    const navigate = useNavigate()
    const { t } = useTranslationHook();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(handlePrivateAuctionDetails({ reset: true }))
    }, [])

    return (
        <>
            <Helmet>
                <meta
                    name="keywords"
                    content={t(
                        "Bidhome-Adres, CRE, brokers, investment, commercial real estate, sales, auction"
                    )}
                />
                <meta
                    name="description"
                    content={t(
                        "Bidhome-Adres brings buyers, sellers, and brokers together to efficiently market and close commercial real estate deals in online CRE auctions."
                    )}
                />
                <title>{t("Property Auction - Private Auction Restricted Page")}</title>
            </Helmet>
            <Layout>
                <div
                    className="private-auction-pro"
                >
                    <div className="container py-5">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-6">
                                <div className="box">
                                    <div className='pb-4'>
                                        <img src="/img/lock-icon.svg" alt="" />
                                    </div>
                                    <h2>
                                        {t("Access Restricted")}
                                    </h2>
                                    <p className="lightgray-text">
                                        {t("This account is not authorized or has not been invited to access this private auction. Please contact support for further assistance.")}
                                    </p>

                                    <button
                                        className="btn btn-primary"
                                        onClick={() => navigate("/discover?view=grid")}
                                    >
                                        {t("Back to Auctions")}
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Layout>
        </>

    );
};

export default PrivateAuctionRestricted;